import * as React from "react";
import { Link, RouteComponentProps } from "react-router-dom";
import { connect } from "react-redux";
import * as moment from "moment";

import { Button } from "src/components";
import API from "src/services/api";
import { IStore } from "src/services/store";
import { Canceler } from "axios";
import ListItem from "./components/ListItem";
import Drawer from "./components/Drawer";
import TemplateSelection from "./components/TemplateSelection";

const FORMAT = "DD.MM.YYYY HH:mm";

interface ILinkCreateBulkStartProps extends RouteComponentProps {
  profileParameterName: string;
}
interface ILinkCreateBulkStartState {
  list: any[];
  loadingList: boolean;
  templateSelectionOpen: boolean;
  drawer: {
    item: any;
    copying: boolean;
    open: boolean;
  };
  parameterOrder: Array<{
    name: string;
    order: number;
  }>;
  newBulkId?: number;
}

class LinkCreateBulkStart extends React.Component<
  ILinkCreateBulkStartProps,
  ILinkCreateBulkStartState
> {
  reqCanceler: Canceler | null = null;
  refreshInterval: NodeJS.Timeout;

  state: ILinkCreateBulkStartState = {
    list: [],
    loadingList: false,
    templateSelectionOpen: false,
    drawer: {
      item: null,
      open: false,
      copying: false,
    },
    parameterOrder: [],
    newBulkId: undefined,
  };

  componentDidMount() {
    const { location } = this.props;
    const locationState = location && location.state;
    if (locationState && locationState.newBulkId) {
      this.setState({
        newBulkId: locationState.newBulkId,
      });
    }
    this.initialLoad();
    this.refreshInterval = setInterval(this.loadList, 5000);
  }

  componentWillUnmount() {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
    clearInterval(this.refreshInterval);
  }

  loadList = async () => {
    if (this.reqCanceler) {
      this.reqCanceler();
    }
    const { getData, cancel } = API.LINK_UPLOAD.getBulkUploads();
    this.reqCanceler = cancel;
    const list = await getData();
    this.setState({
      list: list.map((item: any) => ({
        ...item,
        createdOn: moment(item.firstUploadOn).format(FORMAT),
      })),
    });
    this.reqCanceler = null;
  };

  initialLoad = async () => {
    this.setState({ loadingList: true });
    const { getData } = API.ADMIN.PARAMETERS.get();
    const parameters = await getData();
    await this.loadList();
    this.setState({
      loadingList: false,
      parameterOrder: parameters.map((p) => ({
        name: p.name,
        order: p.orderRender,
      })),
    });
  };

  startBulkWithCopy = (market: string, template: string, links: any[]) => {
    const location = {
      pathname: `/link-bulk-upload/create/${market}/${template}`,
      state: { links },
    };
    this.props.history.push(location);
  };

  openLinksInDrawer = (item: any, copying = false) => {
    this.setState({
      drawer: {
        item,
        copying,
        open: true,
      },
    });
  };

  closeDrawer = () => {
    this.setState((state) => ({
      drawer: {
        ...state.drawer,
        open: false,
      },
    }));
  };

  toggleTemplateSelection = () => {
    this.setState((state) => ({
      templateSelectionOpen: !state.templateSelectionOpen,
    }));
  };

  toggleLinksInDrawer = (item: any, isOpen: boolean) => (copying: boolean) => {
    if (this.state.drawer.copying !== copying) {
      this.openLinksInDrawer(item, copying);
      return;
    }
    if (isOpen) {
      this.closeDrawer();
    } else {
      this.openLinksInDrawer(item, copying);
    }
  };

  render() {
    const {
      list,
      loadingList,
      templateSelectionOpen,
      drawer,
      newBulkId,
      parameterOrder,
    } = this.state;
    return (
      <div className="max-w-xl mx-auto my-16 px-4">
        <div className="flex items-start">
          <div className="sticky pin-t py-8 mt-8 mr-16">
            <h3 className="font-normal mb-4">Create new bulk upload</h3>
            <div className="relative">
              <Button
                primary={true}
                onClick={this.toggleTemplateSelection}
                className="block mb-2"
              >
                within Link Manager
              </Button>
              {templateSelectionOpen && (
                <TemplateSelection
                  profileParameterName={this.props.profileParameterName}
                />
              )}
            </div>

            <Button
              as={Link}
              to="/link-bulk-upload/with-excel"
              className="block"
            >
              with Excel
            </Button>
          </div>
          <div className="flex-1">
            <h1 className="text-2xl mb-8">Bulk Upload History</h1>
            <ul className="list-reset">
              {loadingList
                ? Array.from({ length: 10 }).map((_, index) => (
                    <div key={index} className="loader opacity-50 h-16 mb-2" />
                  ))
                : list.map((item) => {
                    const isOpen = drawer.open && drawer.item.id === item.id;
                    return (
                      <ListItem
                        item={item}
                        key={item.id}
                        openLinks={this.toggleLinksInDrawer(item, isOpen)}
                        drawerOpen={isOpen}
                        newBulkId={newBulkId}
                        profileParameterName={this.props.profileParameterName}
                      />
                    );
                  })}
            </ul>
          </div>
        </div>

        {drawer.item && (
          <Drawer
            {...drawer}
            close={this.closeDrawer}
            startBulkWithCopy={this.startBulkWithCopy}
            profileParameterName={this.props.profileParameterName}
            parameterOrder={parameterOrder}
          />
        )}
      </div>
    );
  }
}

export default connect(({ settings: { profileParameterName } }: IStore) => ({
  profileParameterName,
}))(LinkCreateBulkStart);



// WEBPACK FOOTER //
// ./src/views/LinkCreateBulkStart/LinkCreateBulkStart.tsx